var map = {
	"./account.js": [
		973,
		32
	],
	"./contact.js": [
		974,
		35
	],
	"./ecommerce.js": [
		975,
		36
	],
	"./navigation.js": [
		976,
		37
	],
	"./news.js": [
		977,
		38
	],
	"./survey.js": [
		978,
		77
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 842;
module.exports = webpackAsyncContext;